import moment from "moment";

export const getDobInputValue = dob => {
  if (dob == null || dob === 0) return "";
  if (typeof dob !== "number") return String(dob).trim();
  const date = moment(dob);
  // Legacy epoch placeholders must not count as a supplied birthday.
  if (!date.isValid() || date.format("DDMMYYYY") === "01011970") return "";
  return date.format("DDMMYYYY");
};

export const validateRegistrationDob = (dob, required) => {
  const input = getDobInputValue(dob);
  if (!input) return { value: 0, error: required ? "Please Input your DOB" : null };
  const date = moment(input, "DDMMYYYY", true);
  if (!/^\d{8}$/.test(input) || !date.isValid() || date.isAfter(moment(), "day")) {
    return { value: 0, error: required ? "Incorrect DOB Format" : null };
  }
  return { value: date.valueOf(), error: null };
};
